module.exports = __webpack_public_path__ + "img/jl.4371afa1.svg";